import { render } from "./LayoutOrder.vue?vue&type=template&id=06587780&ts=true"
import script from "./LayoutOrder.vue?vue&type=script&lang=ts"
export * from "./LayoutOrder.vue?vue&type=script&lang=ts"

import "./LayoutOrder.vue?vue&type=style&index=0&id=06587780&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__